import Vue from "vue";

Vue.filter('max_99', function (value) {
    value = parseInt(value);
    return ( value > 99)?  '+99': value;
});